export default {
  loadNavDropdown() {
    const dropdownToggle = document.getElementById('mobileHamburger')
    const dropdownNav = document.getElementById('dropdownNav')
    let dropdownShowing = false

    if (dropdownToggle && dropdownNav) {
      dropdownToggle.addEventListener('click', () => {
        if(dropdownShowing){
          dropdownToggle.classList.remove('is-active')
          dropdownNav.classList.remove('is-active')
          dropdownShowing = false
        } else {
          dropdownToggle.classList.add('is-active')
          dropdownNav.classList.add('is-active')
          dropdownShowing = true
        }
      }, false)
    }
  }
}
